import { useState, useEffect } from "react";
import { supabase } from "../lib/supabase";

/**
 * Returns the current user's subscription plan.
 *
 * plan: "free" | "pro" | "team"
 * loading: boolean
 * isPro: boolean  (pro OR team)
 * isTeam: boolean
 *
 * Usage:
 *   const { plan, isPro, loading } = useSubscription(user?.id);
 *   if (!isPro) return <UpgradePrompt />;
 */
export function useSubscription(userId) {
  const [plan,    setPlan]    = useState("free");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!supabase || !userId) {
      setPlan("free");
      setLoading(false);
      return;
    }

    let cancelled = false;

    supabase
      .from("subscriptions")
      .select("plan_id, status, current_period_end")
      .eq("user_id", userId)
      .eq("status", "active")
      .gt("current_period_end", new Date().toISOString())
      .maybeSingle()
      .then(({ data, error }) => {
        if (cancelled) return;
        if (error) console.error("[useSubscription]", error);
        setPlan(data?.plan_id ?? "free");
        setLoading(false);
      });

    return () => { cancelled = true; };
  }, [userId]);

  return {
    plan,
    loading,
    isPro:  plan === "pro"  || plan === "team",
    isTeam: plan === "team",
  };
}
